<template>
    <div class="accordion">
        <div class="header" :class="{'cursor-pointer': auto}" @click="toggle">
            <slot name="header" :accordion="accordion"></slot>
        </div>
        <transition
            name="accordion"
            @before-enter="beforeEnter"
            @enter="enter"
            @before-leave="beforeLeave"
            @leave="leave"
        >
            <div class="body" v-if="show">
                <slot name="content" :accordion="accordion"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            auto: {
                type: Boolean,
                default: true,
            },
            shown: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                show: this.shown,
            };
        },
        computed: {
            accordion() {
                return {
                    isShown: this.show,
                    setVisibility: this.setShow,
                    toggle: this.manualToggle,
                };
            },
        },
        methods: {
            manualToggle() {
                this.show = !this.show;
            },
            setShow(value) {
                this.show = value;
            },
            toggle() {
                if (this.auto) {
                    this.show = !this.show;
                }
            },
            beforeEnter(el) {
                el.style.height = '0';
            },
            enter(el) {
                this.$nextTick(() => {
                    el.style.height = `${el.scrollHeight}px`;
                });
            },
            beforeLeave(el) {
                el.style.height = `${el.scrollHeight}px`;
            },
            leave(el) {
                el.style.height = '0';
            },
        },
    };
</script>
